import React from 'react';
import { HelpCircle } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../data/mock';

const FAQ = () => {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-50 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-slate-50 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-blue-500 font-bold text-sm uppercase tracking-wider bg-blue-50 px-4 py-2 rounded-full border border-blue-200">
              <HelpCircle className="w-4 h-4 inline mr-2" />
              Got Questions?
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-slate-900 mb-6">
            Frequently Asked <span className="text-blue-500">Questions</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed">
            Find answers to common questions about our services, process, and what to expect when working with CRS Tech.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={faq.id}
                value={`item-${faq.id}`}
                className="border-2 border-slate-200 rounded-2xl bg-white px-6 hover:border-blue-300 hover:shadow-lg transition-all duration-300 overflow-hidden"
              >
                <AccordionTrigger className="text-left hover:no-underline py-6 group">
                  <div className="flex items-start space-x-4 w-full">
                    <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1 group-hover:scale-110 transition-transform duration-300">
                      <span className="text-white font-black text-sm">{faq.id}</span>
                    </div>
                    <span className="text-lg font-bold text-slate-900 group-hover:text-blue-500 transition-colors duration-300 pr-4">
                      {faq.question}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed text-base pb-6 pl-12 pr-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Additional Help CTA */}
        <div className="mt-16 bg-gradient-to-r from-blue-500 to-blue-600 rounded-3xl p-12 max-w-4xl mx-auto shadow-2xl text-center">
          <h3 className="text-3xl font-black text-white mb-4">Still Have Questions?</h3>
          <p className="text-white text-lg mb-6 opacity-95">
            Our team is here to help! Contact us for personalized answers and expert guidance.
          </p>
          <a
            href="#contact"
            className="inline-block bg-white text-blue-500 hover:bg-blue-50 px-10 py-4 rounded-xl font-black text-lg shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
          >
            Get in Touch
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;